export default __webpack_public_path__ + "static/media/hand.a390e592.png";